module.exports = {"id":"211385","name":"Riza Durmisi","rating":"73","photo":"./data/images/photos/2/211385.png","club":{"name":"Real Betis","logo":"./data/images/clubs/RealBetis.png"},"positions":["DG","DLG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RizaDurmisi0.json
// module id = 3619
// module chunks = 0